import React from 'react'
import CardForm from './CardForm'

export default function CheckoutNewPaymentMethod(props) {
  return (
    <CardForm
      onSuccess={props.onSuccess} />
  )
}
